export const STORE_CONFIG_REQUEST = "STORE_CONFIG_REQUEST";
export const STORE_CONFIG_SUCCESS = "STORE_CONFIG_SUCCESS";
export const STORE_CONFIG_FAIL = "STORE_CONFIG_FAIL";
